import { Box, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';
import renderMarkdown from 'util/renderMarkdown';

const MarkdownContainer: React.FC<{ content: string }> = ({ content }) => {
  const [renderedContent, setRenderedContent] = useState<string>('');

  const theme = useTheme();

  useEffect(() => {
    const processMarkdown = async () => {
      const html = await renderMarkdown(content);
      setRenderedContent(html);
    };

    processMarkdown();
  }, [content]);

  return (
    <Box
      sx={{
        '& p': {
          fontSize: '13px',
          lineHeight: 'normal',
          fontFamily: theme.typography.fontFamily,
          margin: "3px 0"
        },
        '& h1': {
          fontSize: '15px',
          fontWeight: theme.typography.h3.fontWeight,
          margin: '0.5 0',
        },
        '& h2': {
          fontSize: '15px',
          fontWeight: theme.typography.h4.fontWeight,
          marginBottom: '0.3 0',
        },
      }}
      dangerouslySetInnerHTML={{ __html: renderedContent }}
    />
  );
};

export default MarkdownContainer;
